import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogIdeasListRoute extends Route {
  @service store;

  model() {
    return [];
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.set('list', model);
    if (controller.get('columns').length === 0) {
      const columns = controller.get('columnOptions').reduce((acc, item) => {
        if (item.show === undefined) acc.push(item.value);
        else if (item.show === true) acc.push(item.value);
        return acc;
      }, []);
      controller.set('columns', columns);
    }
  }

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      controller.set('selectedIdeas', []);
    }
  }
}

export default instrumentRoutePerformance(BacklogIdeasListRoute);
